import { Directive, Input, forwardRef } from '@angular/core'
import {
    NG_VALIDATORS,
    Validator,
    AbstractControl,
    Validators,
    ValidationErrors
} from '@angular/forms'

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[max]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: MaxDirective, multi: true }
    ]
})
export class MaxDirective implements Validator {
    @Input() max: number

    validate(control: AbstractControl): ValidationErrors {
        return Validators.max(this.max)(control)
    }
}



// WEBPACK FOOTER //
// ./src/app/common/max.directive.ts